import { Signals } from "@/Imports";
import Config from "@/config/Config"
import "pixi-assetslist-loader"
import * as PIXI from "pixi.js"
import * as WebFont from "webfontloader";
import brandedVersions from "@/config/BrandedVersions";
import { processUrlInCaseFailOverIsRequired } from "@/utils/urlUtils";

export default class ApplicationLoader {

  loadPreloadingAssets({ ct: casinoToken }) {
    const config = brandedVersions.versions[casinoToken.toLowerCase()] || brandedVersions.versions.default;

    PIXI.Loader.shared.add(config.preloaderAssetsConfigPath);
    PIXI.Loader.shared.onComplete.once(this.onLoadPreloadingAssetsComplete)
    PIXI.Loader.shared.onError.add(this.onError)

    PIXI.Loader.shared.load()
  }


  onError(e) {
    console.log(e)
  }

  loadMainGameAssets({ ct: casinoToken }) {
    const config = brandedVersions.versions[casinoToken.toLowerCase()] || brandedVersions.versions.default;

    PIXI.Loader.shared.add(config.assetsConfigPath);
    PIXI.Loader.shared.onComplete.once(this.onLoadMainGameAssetsComplete)
    PIXI.Loader.shared.onProgress.add((e) => {
      Signals.loadingProgress.dispatch(e.progress)
      const progress = Number(e.progress).toFixed(Config.TO_FIXED_VALUES) / 100
      document.dispatchEvent(new CustomEvent('onprogress', { detail: { "value": progress } }));
    })
    PIXI.Loader.shared.load()
  }

  //private
  onLoadPreloadingAssetsComplete = () => {
    Config.pattern = PIXI.Loader.shared.resources['pattern'].data
    this.loadFonts()
  }

  //private
  onLoadMainGameAssetsComplete = () => {
    const entries = Object.entries(PIXI.Loader.shared.resources)
    this.textures = []
    for (let i = 0; i < entries.length; i++) {
      let res = entries[i][1]
      if (res.texture) {
        this.textures.push(res.texture)
      }
    }

    this.prepare(this.textures, 0)
  }

  //private
  loadFonts() {
    this.fonts = Config.fonts
    WebFont.load({
      custom: {
        families: this.fonts,
        urls: [processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/font/fonts/stylesheet.css`)]
      },
      active: (event) => {
        setTimeout(() => {
          Signals.preloaderAssetsLoadingComplete.dispatch()
        }, 0);
      }
    });
  }

  //private
  prepare = (textures, index) => {
    Config.app.renderer.plugins.prepare.upload(textures[index], () => {
      if (index + 1 <= this.textures.length - 1) {
        this.prepare(textures, index + 1)
      } else {
        Signals.mainGameAssetsLoadingComplete.dispatch()
      }
    });
  }

}
